import { Attachments } from '@/models/Posts';
import { convertSlugToString, isArray } from '@/utils/helper';
import LazyImage from '../LazyImage';
import YouTubeEmbedVideo from '../YoutubeEmbedVideo';
interface Props {
  attachments: Attachments;
  slug?: string;
}
const MediaCard = ({
  attachments,
  slug
}: Props) => {
  const getMedia = () => {
    const {
      images,
      video_links,
      videos,
      audios
    } = attachments;
    if (isArray(videos)) {
      return <div className="w-full h-full">
          <YouTubeEmbedVideo videoSrc={videos[0]} title={slug ? convertSlugToString(slug) : ''} />
        </div>;
    }
    if (isArray(video_links)) {
      return <div className="w-full h-full">
          <YouTubeEmbedVideo videoSrc={video_links[0]} title={slug ? convertSlugToString(slug) : ''} />
        </div>;
    }
    if (isArray(images)) {
      return <div className={'relative flex justify-center w-full h-full'}>
          <LazyImage imageUrl={images[0]} alt={slug || ''} fallBackIcon={<></>} className="w-full h-full" />
        </div>;
    }
    //TODO:: How to play audios
    if (isArray(audios)) {
      return <div className="w-full" data-testid={`audio-player-${slug}`}>
          <audio controls src={audios[0]} className="w-full" />
        </div>;
    }
  };
  return <div className="w-full h-full" data-sentry-component="MediaCard" data-sentry-source-file="MediaCard.tsx">{getMedia()}</div>;
};
export default MediaCard;